import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=b865f1a8&scoped=true"
import script from "./SerialNumber.vue?vue&type=script&lang=js"
export * from "./SerialNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b865f1a8",
  null
  
)

export default component.exports